// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-location {
    width: 80%;      
    height:40%;   
    padding: 20px;         
    border-radius: 10px;
    overflow-y:scroll;
    z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/css/reportLocation.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB","sourcesContent":[".report-location {\n    width: 80%;      \n    height:40%;   \n    padding: 20px;         \n    border-radius: 10px;\n    overflow-y:scroll;\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
